import { render, staticRenderFns } from "./ExpensesTypeInfo.vue?vue&type=template&id=5f65051c&"
import script from "./ExpensesTypeInfo.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports